import { InputText } from 'primeng/inputtext';

import { FieldTree } from '@angular/forms/signals';
import { FormField } from '@angular/forms/signals';
import { input, signal, Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

import { SvgIcon } from '../svg-icon';

@Component({
  selector: 'app-password-input',
  templateUrl: './password-input.html',
  styleUrl: './password-input.scss',
  standalone: true,
  imports: [InputText, SvgIcon, FormField],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'password-input',
  },
})
export class PasswordInput {
  public formField = input<FieldTree<string, string>>();
  public isPasswordShown = signal(false);

  protected showHidePassword(): void {
    this.isPasswordShown.set(!this.isPasswordShown());
  }
}
